module.exports = __webpack_public_path__ + "static/media/lock.75088d5a.svg";